import React, { useEffect, useState } from "react";
import { IStackStyles, Stack, StackItem } from "@fluentui/react/lib/Stack";
import strings from "../../loc/strings";
import {
  DefaultButton,
  IconButton,
  PrimaryButton,
} from "@fluentui/react/lib/Button";
import {
  DetailsList,
  FontWeights,
  IDropdownOption,
  IIconProps,
  Label,
  Modal,
  SelectionMode,
  Selection,
  Spinner,
  getTheme,
  mergeStyleSets,
  IObjectWithKey, IColumn, IDetailsListProps, IDetailsRowStyles, DetailsRow, TooltipOverflowMode, IModalProps,
} from "@fluentui/react";
import Pagination from "../Pagination/Pagination";
import {
  AssessmentItem,
  AssessmentResultItem,
} from "../../model/AssessmentResultItem";
import {
  fetchCreateAssessmentResults,
  fetchViewAssessmentResults,
} from "../../services/AssessmentServices/AssessmentService";
import { useAuth } from "react-oidc-context";
import {useBoolean} from "@fluentui/react-hooks";
import {SORT_ORDER_ASC, SORT_ORDER_DESC} from "../../constants/EiopaFnPConstants";
import styles from "./Assessment.module.css";
import {TooltipHost} from "@fluentui/react/lib/Tooltip";
interface AssessmentProps {
  hideModal: any;
  isModalOpen: any;
  readOnly: boolean;
  modalAction: string;
  personId: number;
  name: string;
  EncryptedId: string;
}

interface AssessmentForm {
  itemsPerPage: number;
  page: number;
  sortBy: any;
  sortOrder: any;
}

const stackStylesButtons: Partial<IStackStyles> = {
  root: {
    marginRight: "10px",
  },
};


const theme = getTheme();

const contentStyles = mergeStyleSets({
  container: {
    // display: "flex",
    // flexFlow: "column nowrap",
    // alignItems: "stretch",
    padding: "10px",
    // overflowX: "hidden",
  },
  header: [
    {
      flex: "1 1 auto",
      display: "flex",
      fontWeight: FontWeights.semibold,
    },
  ],
  heading: {
    color: theme.palette.neutralPrimary,
    fontWeight: FontWeights.semibold,
    fontSize: "inherit",
    margin: "0",
  },
  body: {
    flex: "4 4 auto",
    padding: "0 24px 24px 24px",
    overflowY: "hidden",
    selectors: {
      p: { margin: "14px 0" },
      "p:first-child": { marginTop: 0 },
      "p:last-child": { marginBottom: 0 },
    },
  },
});

const modalStyles = {
  main: {
    selectors: {
      ['@media (min-width: 480px)']: {
        width: '100%',
        maxWidth: '1180px',
      },
      ['.ms-List-page .ms-List-cell:empty']: {
        display: 'none',
      },
    },
  },
};

const iconButtonStyles = {
  root: {
    color: theme.palette.neutralPrimary,
    marginLeft: "auto",
    marginRight: "2px",
  },
  rootHovered: {
    color: theme.palette.neutralDark,
  },
};

const modalListStyles = {
  root: {
    overflowY: "hidden",
    selectors: { ".ms-List-cell": { minHeight: 0 } },
  },
  scrollContainer: {
    // overflowX: "auto",
    overflowY: "hidden",
  },
};

interface AssessmentState {
  loading: boolean;
  isResultsFetched: boolean;
  currentPage: number;
  isIconClickHandled: boolean;
  itemsPerPage:number;
  assessmentResult: AssessmentResultItem;
  assessmentResultSliced: AssessmentItem[];
  assessmentForm: AssessmentForm;
  selectedItems: AssessmentItem[];
  selectedItemsKeys: number[];
  sortBy: string;
  isSorted: boolean;
  columns:IColumn[];
}

function Assessment(props: Readonly<AssessmentProps>) {
  const cancelIcon: IIconProps = { iconName: "Cancel" };
  const [isSortedDescendings, { toggle: toggleIsSortedDescendings }] = useBoolean(true);
  const _columns:IColumn[] = [
    {
      key: "AssessingCA",
      name: "Assessing CA",
      fieldName: "AssessingCA",
      ariaLabel: "AssessingCAName",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true
    },
    {
      key: "CACode",
      name: "CA code",
      fieldName: "CACode",
      ariaLabel: "AssessingCAId",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "CAInternalAssessmentNo",
      name: "CA internal assessment number",
      fieldName: "CAInternalAssessmentNo",
      ariaLabel: "InternalCARefNo",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "EUSectoralLegislativeBasis",
      name: "EU sectoral legislative basis",
      fieldName: "EUSectoralLegislativeBasis",
      ariaLabel: "EUSectoralLegislatureBasisId",
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "DateOfAssessment",
      name: "Date of assessment",
      fieldName: "DateOfAssessment",
      ariaLabel: "SubmissionDate",
      isSorted:true,
      isSortedDescending:isSortedDescendings,
      minWidth: 200,
      maxWidth: 200,
      isResizable: true,
    },
  ];

  const modalProps: IModalProps = {
    isBlocking: true,
  };

  const [state, setState] = React.useState<AssessmentState>({
    loading: false,
    isResultsFetched: false,
    currentPage: 1,
    itemsPerPage: 10,
    isIconClickHandled: false,
    selectedItems: [],
    sortBy:"SubmissionDate",
    isSorted:false,
    columns : _columns,
    assessmentResult: {
      results: [
        {
          personId: 0,
          assessingCompetentAuthority: "",
          caCode: "",
          caInternalAssessmentNo: "",
          euSectoralLegislativeBasis: "",
          dateOfAssessment: "",
          assessmentId: 0,
          encryptedId: "",
        },
      ],
      totalItems: 0,
      totalPages: 0,
    },
    assessmentResultSliced:[
      {
        personId: 0,
        assessingCompetentAuthority: "",
        caCode: "",
        caInternalAssessmentNo: "",
        euSectoralLegislativeBasis: "",
        dateOfAssessment: "",
        assessmentId: 0,
        encryptedId: "",
      },
    ],
    selectedItemsKeys :[],
    assessmentForm: {
      itemsPerPage: 10,
      page: 1,
      sortBy: "SubmissionDate",
      sortOrder: "desc",
    },
  });

  const [selection] = useState<Selection>(
      new Selection({
        onSelectionChanged: () => {
          setState((prevState) => ({
            ...prevState,
            selectedItems: selection.getSelection() as AssessmentItem[],
          }));
        },
        items: state.selectedItems,
        getKey: (item: AssessmentItem) => item.assessmentId,
      })
  );

  const isDisabled = () => {
    const selectedCount = state.selectedItems.length;
    return selectedCount === 0;
  };

  const _onRenderRow: IDetailsListProps['onRenderRow'] = props => {
    const customStyles: Partial<IDetailsRowStyles> = {};

    if (props) {
      let currentPage =state.currentPage;
      let itemsPerPage = state.itemsPerPage;

      const firstIndexRow =  (currentPage-1)*itemsPerPage;
      const lastIndexRow =  (currentPage-1)*itemsPerPage + itemsPerPage;

      if(!(props.itemIndex < lastIndexRow && props.itemIndex >= firstIndexRow)){
        customStyles.root = { display: "none" };
      }

      return <DetailsRow {...props} styles={customStyles} />;
    }
    return null;
  };

  function _onColumnHeaderClick(ev?: React.MouseEvent<HTMLElement>, column?: IColumn) {
    if(column === undefined) return;
    toggleIsSortedDescendings();

    let isSortedDescending = column.isSortedDescending;

    if (column.isSorted) {
      isSortedDescending = !isSortedDescending;
    }

    let columns = state.columns.map(col => {
      col.isSorted = col.key === column.key;
      if (col.isSorted) {
        col.isSortedDescending = isSortedDescending;
      }
      return col;
    });

    let assesment = state.assessmentForm;
    assesment.sortBy = columns.filter(c => c.isSorted)[0].ariaLabel
    assesment.sortOrder= columns.filter(c => c.isSorted)[0].isSortedDescending ? SORT_ORDER_DESC : SORT_ORDER_ASC

    setState((prevState) => ({
      ...prevState,
      assessmentForm: assesment
    }));
    _handleIconClick();
  }

  const _itemsView = () => {
    const filteredItems = state.assessmentResult.results.map(
        (item) =>
            ({
              AssessingCA: item.assessingCompetentAuthority,
              CACode: item.caCode,
              CAInternalAssessmentNo: item.caInternalAssessmentNo,
              EUSectoralLegislativeBasis: item.euSectoralLegislativeBasis,
              DateOfAssessment: item.dateOfAssessment,
              assessmentId: item.assessmentId,
              key: item.assessmentId,
            } as IObjectWithKey)
    );

    return filteredItems;
  };

  const _itemsCreate = () => {
    const filteredItems = state.assessmentResult.results.map(
        (item) =>
            ({
              AssessingCA: item.assessingCompetentAuthority,
              CACode: item.caCode,
              CAInternalAssessmentNo: item.caInternalAssessmentNo,
              EUSectoralLegislativeBasis: item.euSectoralLegislativeBasis,
              DateOfAssessment: item.dateOfAssessment,
              assessmentId: item.assessmentId,
              encryptedId: item.encryptedId,
              key: item.assessmentId,
            } as IObjectWithKey)
    );

    return filteredItems;
  };

  const handleItemSelection = () => {
    window.open(
        `/new-request-for-information/${
            props.EncryptedId
        }?assessmentId=${state.selectedItems
            .map((item) => {
              return item.encryptedId;
            })
            .join(",")}`
    );
    props.hideModal();
  };

  const _onChangeItemsPerPage = async (
      event: React.FormEvent<HTMLDivElement>,
      item: IDropdownOption
  ) => {
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      let data: any = undefined;

      data = state.assessmentResult;


      setState((prevState) => {
        return {
          ...prevState,
          assessmentResult: data,
          assessmentForm: {
            ...prevState.assessmentForm,
            itemsPerPage: item.key as number,
          },
          itemsPerPage:item.key as number,
          currentPage: 1,
          loading: false,
        };
      });
    } catch (error) {
      // Handle error if needed
    }
  };

  const _onPageChange = async (selectedPage: number) => {
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      let data: any = undefined;
      data = state.assessmentResult;
      setState((prevState) => ({
        ...prevState,
        assessmentResult: data,
        selectedItems: selection.getSelection() as AssessmentItem[],
        loading: false,
        currentPage: selectedPage,
        assessmentForm: {
          ...prevState.assessmentForm,
          page: selectedPage,
        },
      }));
    } catch (error) {
      console.log(error)
    }
  };

  const _onClose = () => {
    props.hideModal();
  };

  const auth = useAuth();

  const _handleIconClick = async (page?: number) => {
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));

    try {
      let data: any = undefined;
      if (props.modalAction === strings.viewAssessmentsLabel) {
        data = await fetchViewAssessmentResults(
            props.EncryptedId,
            {
              ...state.assessmentForm,
              itemsPerPage: state.assessmentForm.itemsPerPage,
              page: state.currentPage,
            },
            auth.user?.id_token
        );
      } else if (props.modalAction === strings.selectCARecipientsLabel) {
        data = await fetchCreateAssessmentResults(
            props.EncryptedId,
            {
              ...state.assessmentForm,
              itemsPerPage: state.assessmentForm.itemsPerPage,
              page: state.currentPage,
            },
            auth.user?.id_token
        );
      }

      setState((prevState) => ({
        ...prevState,
        assessmentResult: data,
        assessmentResultSliced: data.results.slice((prevState.currentPage-1) * prevState.itemsPerPage,(prevState.currentPage-1) * prevState.itemsPerPage +prevState.itemsPerPage),
        isResultsFetched: true,
      }));
    } catch (error) {
      // Handle error if needed
    } finally {
      setState((prevState) => ({
        ...prevState,
        loading: false,
        currentPage: 1
      }));
    }
  };

  useEffect(() => {
    if (props.isModalOpen) {
      _handleIconClick(state.currentPage);
    }
  }, [props.isModalOpen]);

  function _renderItemColumn(item?: any, index?: number, column?: IColumn) {
    if(item && column) {
      const fieldContent = item[column.fieldName as keyof any] as string;
      return <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={fieldContent}>{fieldContent}</TooltipHost>
    }
  }

  const addTooltipToColumnHeader = (cols: IColumn[]) => {
    cols.forEach(col => {
      col.onRenderHeader= (props) => {
        return <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={props?.column.name}>{props?.column.name}</TooltipHost>
      }
    });
    return cols;
  };

  const renderContent = () => {
    if (state.loading) {
      return <Spinner label={strings.spinnerLabel} />;
    }

    if (state.isResultsFetched) {
      if (props.modalAction === strings.viewAssessmentsLabel) {
        return (
            <>
              <DetailsList
                  layoutMode={1}
                  setKey="set"
                  columns={addTooltipToColumnHeader(state.columns)}
                  items={_itemsView()}
                  onColumnHeaderClick={_onColumnHeaderClick}
                  selectionMode={SelectionMode.none}
                  onRenderRow={_onRenderRow}
                  selectionPreservedOnEmptyClick={true}
                  onRenderItemColumn={_renderItemColumn}
                  styles={modalListStyles}
              />
              <Pagination
                  currentPage={state.currentPage}
                  onPageChange={_onPageChange}
                  itemsPerPage={state.itemsPerPage}
                  onChangeItemsPerPage={_onChangeItemsPerPage}
                  totalItems={state.assessmentResult.totalItems}
              />
              <Stack horizontal horizontalAlign="end">
                <StackItem styles={stackStylesButtons}>
                  <DefaultButton text={strings.closeButtonText} onClick={_onClose} />
                </StackItem>
              </Stack>
            </>
        );
      }

      if (props.modalAction === strings.selectCARecipientsLabel) {
        return (
            <>
              <div className={styles.msListCell}>
                <DetailsList
                    layoutMode={1}
                    columns={addTooltipToColumnHeader(state.columns)}
                    items={_itemsCreate()}
                    selectionMode={SelectionMode.multiple}
                    onRenderRow={_onRenderRow}
                    selectionPreservedOnEmptyClick={true}
                    onColumnHeaderClick={_onColumnHeaderClick}
                    selection={selection}
                    getKey={(item: AssessmentItem) => item.assessmentId.toString()}
                    setKey="set"
                    onRenderItemColumn={_renderItemColumn}
                    styles={modalListStyles}
                />
              </div>
              <Pagination
                  currentPage={state.currentPage}
                  onPageChange={_onPageChange}
                  itemsPerPage={state.itemsPerPage}
                  onChangeItemsPerPage={_onChangeItemsPerPage}
                  totalItems={state.assessmentResult.totalItems}
              />
              <Stack horizontal horizontalAlign="end">
                <StackItem styles={stackStylesButtons}>
                  <PrimaryButton
                      text={strings.selectAndProceedText}
                      onClick={handleItemSelection}
                      disabled={isDisabled()}
                  />
                </StackItem>
                <StackItem styles={stackStylesButtons}>
                  <DefaultButton text={strings.closeButtonText} onClick={_onClose} />
                </StackItem>
              </Stack>
            </>
        );
      }

      return null;
    }

    return null;
  };

  return (
      <Modal
          isOpen={props.isModalOpen}
          onDismiss={props.hideModal}
          isModeless={false}
          containerClassName={contentStyles.container}
          styles={modalStyles}
          isBlocking={true}
      >
        <Stack horizontal>
          <StackItem>
            <Label>
              {props.modalAction === strings.viewAssessmentsLabel ? (
                  <span>
              <span style={{ fontSize: '20px', marginRight: '5px' }}>{strings.viewAssessmentsLabel}</span>
              (for: {props.name})
            </span>
              ) : (
                  <span>
              <span style={{ fontSize: '20px', marginRight: '5px' }}>{strings.selectCARecipientsLabel}</span>
              (to request information for: {props.name})
            </span>
              )}
            </Label>
          </StackItem>
          <StackItem className={contentStyles.header}>
            <IconButton
                styles={iconButtonStyles}
                iconProps={cancelIcon}
                ariaLabel="Close popup modal"
                onClick={props.hideModal}
            />
          </StackItem>
        </Stack>
        <Stack>
          <br />
          <StackItem>{renderContent()}</StackItem>
        </Stack>
      </Modal>
  );

}

export default Assessment;
